"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = request;

var _url = _interopRequireDefault(require("./url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function request() {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var _ref,
        base,
        fragment,
        _ref$method,
        method,
        _ref$data,
        data,
        _ref$params,
        params,
        _ref$token,
        token,
        _ref$userAgent,
        userAgent,
        url,
        json,
        requestData,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, base = _ref.base, fragment = _ref.fragment, _ref$method = _ref.method, method = _ref$method === void 0 ? 'GET' : _ref$method, _ref$data = _ref.data, data = _ref$data === void 0 ? null : _ref$data, _ref$params = _ref.params, params = _ref$params === void 0 ? null : _ref$params, _ref$token = _ref.token, token = _ref$token === void 0 ? null : _ref$token, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? null : _ref$userAgent;
            url = (0, _url["default"])({
              base: base,
              fragment: fragment,
              params: params
            });
            json = data && JSON.stringify(data);
            requestData = {
              method: method,
              credentials: 'include',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            };

            if (token) {
              requestData.headers['Authorization'] = "JWT ".concat(token);
              requestData.credentails = 'omit';
            }

            if (userAgent) {
              requestData.headers['User-Agent'] = userAgent;
            }

            if (json) requestData.body = json;
            console.info("API request: ".concat(method, " ").concat(url));
            _context.next = 10;
            return fetch(url, requestData);

          case 10:
            return _context.abrupt("return", _context.sent);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _request.apply(this, arguments);
}